import { TProvider } from '@wojtekmaj/react-t';
import { I18nProvider as ReactAriaI18nProvider, useLocale } from 'react-aria-components';

import { defaultLocale, languageFiles, supportedLocales } from './i18n';

type I18nProviderProps = {
  children: React.ReactNode;
};

export default function I18nProvider({ children }: I18nProviderProps) {
  const { locale } = useLocale();

  const languageCode = locale.split('-')[0];

  const supportedLocale =
    languageCode && supportedLocales.includes(languageCode) ? languageCode : defaultLocale;

  return (
    <TProvider defaultLocale={defaultLocale} languageFiles={languageFiles} suspend>
      <ReactAriaI18nProvider locale={supportedLocale}>{children}</ReactAriaI18nProvider>
    </TProvider>
  );
}
